import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useLocale } from 'hooks/useLocale';
import { REFINANCING_AMOUNT_THRESHOLD } from 'utils/applications/signup.config';
import { convertCurrencyToNumber } from 'utils/currencyConverter';

// Whether the refinancing feature is available at all for this introducer,
// independent of the amount/purpose the user has entered.
export const useRefinancingEnabled = () => {
  const { isUK } = useLocale();
  const { splitTests } = useIntroducerData();

  return isUK && Boolean(splitTests?.refinancing_introduced_customers_2026);
};

export const useShowRefinancing = ({
  amount,
  loanPurpose,
}: {
  amount?: string;
  loanPurpose?: string;
}) => {
  const refinancingEnabled = useRefinancingEnabled();

  const requestedAmount = convertCurrencyToNumber(amount) || 0;

  return (
    refinancingEnabled &&
    loanPurpose === 'refinancing_debt' &&
    requestedAmount >= REFINANCING_AMOUNT_THRESHOLD
  );
};
